module.exports = __webpack_public_path__ + "img/blanket_produced.3ffe8a14.png";